import React, { useEffect, useState } from "react";
// @mui material components
import Grid from "@mui/material/Grid";
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import ComplexStatisticsCard from "examples/Cards/StatisticsCards/ComplexStatisticsCard";
import fetchData from "verticales/FetchData";
import AppLoading from "verticales/AppLoading.tsx";
import iconERP from "assets/images/icons/iconERP.ico";
import { useNavigate, useLocation } from "react-router-dom";

const url = "https://5djo5qwa3l.execute-api.us-east-1.amazonaws.com/dimo-goyito/ec2/";
const context = "informes";

function ClientesSiesa() {
  const [numeroClientes, setNumeroClientes] = useState(0);
  const [blocking, setBlocking] = React.useState(false);
  const [diferenciaClientesErp, setDiferenciaClientesErp] = useState(0);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const catData = async () => {
      setBlocking(true);
      const data = await fetchData(url, context, { action: "dashboard-clientes-erp" });
      if (data?.rows?.length > 0) {
        const obj = data.rows[0];
        console.log("obj....", obj["numero_clientes"]);
        setNumeroClientes(obj["numero_clientes"]);
      } else if (data?.error == 403) {
        console.log("location.....", location);
        //navigate("/login");
      }
      const diferenciaDataErp = await fetchData(url, context, {
        action: "diferencial-clientes-erp",
      });
      if (diferenciaDataErp?.rows?.length > 0) {
        const obj = diferenciaDataErp.rows[0];
        const diferencia = Number(obj["diferencia"]); // Usamos la columna "diferencia"
        setDiferenciaClientesErp(isNaN(diferencia) ? 0 : diferencia); // Si no es un número, lo define como 0
      }
      setBlocking(false);
    };
    catData();
  }, []);
  return (
    <Grid item xs={12} md={6} lg={3}>
      <MDBox mb={1.5}>
        {blocking ? (
          <AppLoading titleCustom={"Clientes ERP"} />
        ) : (
          <ComplexStatisticsCard
            color="dark"
            icon={<img src={iconERP} />}
            title="Clientes ERP"
            count={numeroClientes}
            percentage={{
              color: "success",
              amount: diferenciaClientesErp,
              label: "Clientes al mes anterior",
            }}
          />
        )}
      </MDBox>
    </Grid>
  );
}

export default ClientesSiesa;
